getExperiment = require 'app/scripts/lib/experiments/simple-test'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_default')

powerUpNavigationItem = t.renderable ({ hasBCPowerUps, hasGoldPowerUps }) ->
  t.li '.board-menu-navigation-item', ->
    t.a '.board-menu-navigation-item-link.js-open-power-ups', { href: '#' }, ->
      t.icon 'power-up', 'power-ups', { class: 'board-menu-navigation-item-link-icon' }
      t.raw '&nbsp;'
      if hasBCPowerUps
        t.icon 'business-class', class: 'mod-quiet'
      else if hasGoldPowerUps
        t.icon 'trello-gold', { class: 'icon-trello-gold-color' }
      t.span '.board-menu-navigation-item-link-count.js-enabled-power-up-count'
      t.span '.board-menu-navigation-item-new.js-power-up-new', ->
        t.format 'new'
      t.span '.board-menu-navigation-item-link-warning.js-power-up-disable-timer'
      t.div '.board-menu-navigation-item-link-summary', ->
        t.raw '&nbsp;'
        t.format 'power-ups-explanation'

module.exports = t.renderable ({ hasBCPowerUps, hasGoldPowerUps, editable, aboutThisBoardEnabled, showEnterpriseUpsell, templateModeEnabled }) ->

  t.p '.error.js-file-too-large', { style: 'margin: 12px 0 6px; display:none;' }, ->
    t.format 'file-too-large-10mb-limit'

  t.ul '.board-menu-navigation', ->

    if aboutThisBoardEnabled
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-about-this-board', { href: "#" }, ->
          t.span '.board-menu-navigation-item-link-icon.icon-lg.icon-board'
          t.raw '&nbsp;'
          if templateModeEnabled
            t.format 'about-this-template'
          else
            t.format 'about-this-board'
          t.div '.board-menu-navigation-item-link-summary.board-menu-about-this-board-summary', ->
            t.raw '&nbsp;'
            if templateModeEnabled
              t.format 'add-a-description-to-your-template'
            else
              t.format 'add-a-description-to-your-board'

    if editable
      t.li '.board-menu-navigation-item.mod-background', ->
        t.a '.board-menu-navigation-item-link.js-change-background', { href: '#' }, ->
          t.span '.board-menu-navigation-item-link-icon.js-fill-background-preview'
          t.raw '&nbsp;'
          t.format 'change-background'

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-card-filter', { href: '#' }, ->
        t.icon 'search', 'search-cards', { class: 'board-menu-navigation-item-link-icon' }

    if editable
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-stickers', { href: '#' }, ->
          t.icon 'sticker', 'stickers', { class: 'board-menu-navigation-item-link-icon' }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-more', { href: '#' }, ->
        t.icon 'overflow-menu-horizontal', 'more', { class: 'board-menu-navigation-item-link-icon' }

    t.div '.js-board-menu-bc-prompt-root'

  if editable
    t.hr()
    if showEnterpriseUpsell
      t.div '.enterprise-up-sell.on-board', ->
        t.div '.enterprise-up-sell-body', ->
          t.div '.enterprise-up-sell-copy', ->
            t.h2 '.enterprise-up-sell-header', ->
              t.span '.icon-lg.icon-power-up'
              t.format 'ads-ent-title'
            t.div '.enterprise-up-sell-description', ->
              t.format 'ads-ent-description'
        t.div '.enterprise-up-sell-footer', ->
          t.div '.enterprise-up-sell-actions', ->
            t.button '.js-enterprise-upsell-dismiss', ->
              t.format 'ads-ent-dismiss'
            t.button '.js-enterprise-upsell-learn-more.button.primary', ->
              t.format 'ads-ent-learn-more'

    t.ul '.board-menu-navigation', ->
      powerUpNavigationItem({ hasBCPowerUps, hasGoldPowerUps })

    t.div '.js-power-up-slots-container'

  if !templateModeEnabled
    t.hr()

    t.a '.board-menu-section-header.js-open-activity', { href: '#' }, ->
      t.span '.board-menu-section-header-icon.icon-lg.icon-activity'
      t.span '.board-menu-section-header-title', ->
        t.format 'activity'
      t.span '.board-menu-section-header-count.js-unread-activity-count'

    t.div '.js-menu-action-list'

    t.a '.show-more.js-fill-activity-button.js-open-activity', { href: '#' }
